import { Component, ElementRef, ViewChild } from '@angular/core';
import { CONFIG } from '../../config';
import { ActivatedRoute } from '@angular/router';
import { isTabView } from '../../utils';
import { INIT_ACTION_TYPE, LOGINTYPE, MYGOORU_AI_CONTEXT_TYPE } from '../../constants/helper-constant';
import { UserService } from '@gooru/my-gooru-ts';
import { UserContextService } from '../../providers/services/user-context.service';
import { OtpService } from '../../providers/services/otp.service';
import { AuthServiceHelper } from '../../providers/services/auth.service';
import { SessionService } from '@gooru/navigator-core-widget-ui';
import { AuthService } from '@gooru/navigator-auth-widget-ui';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-explore',
  templateUrl: './explore.component.html',
  styleUrl: './explore.component.scss'
})
export class ExploreComponent {
  public mygContext!: any;
  @ViewChild('aiContainer') public aiContainer!: ElementRef;
  public isTabView!: boolean;
  public tenantKey!: any;

  constructor(private route: ActivatedRoute, private userService: UserService,
      private userContextService: UserContextService, private otpService: OtpService, private authService: AuthService, private authServiceHelper: AuthServiceHelper, private sessionService: SessionService) { }

  async ngOnInit(): Promise<void> {
    this.isTabView = isTabView();
    const userInfo = this.userService.getUserInfo();
    const userInfoContext = userInfo?.userContext;
    const userContext = this.userContextService.getContact();
    const queryInput = this.route.snapshot.queryParamMap.get('q');
    const queryId = this.route.snapshot.queryParamMap.get('id');
    const markerId = this.route.snapshot.queryParamMap.get('m');
    const secretKey = LOGINTYPE?.SECRET_KEY;
    const urlEncrypted = this.route.snapshot.queryParamMap.get('tenant_id');
    let randomId = (userInfoContext?.id || userContext?.contactType === 'email') ? userContext?.contact : this.generateRandomId();
    const randomUsername = userInfoContext?.username || userInfoContext?.firstname || userContext?.contact || `anonymous_${randomId}_explore`;
    // const randomUsername = rawUsername.replace(/@gooru\.org$/i, '');
    const randomEmail =userInfoContext?.email || (randomUsername.includes('@') ? randomUsername : `${randomUsername}@gooru.org`);
    const { version, clientId, clientKey, appId, defaultUserRole } = CONFIG;
    let effectiveClientId = userInfo?.clientId || clientId;
    let effectiveClientKey = userInfo?.clientKey || clientKey;

    if(userContext?.contactType === 'email') {
      const userDetails = await this.authService?.signInAnonymous(clientId, clientKey);
      const anon_access_token = userDetails?.access_token;
      const userData = await this.authServiceHelper?.getUserData(userContext?.contact, anon_access_token);
      if(userData?.reference_id) {
        randomId = userData?.reference_id;
      }
    }
    
    if (urlEncrypted) {
      const decryptedEncoded = decodeURIComponent(urlEncrypted);
      const decryptedBytes = CryptoJS.AES.decrypt(decryptedEncoded, secretKey);
      const decryptedTenantId = decryptedBytes.toString(CryptoJS.enc.Utf8);
      try {
        const userDetails = await this.authService?.signInAnonymous(clientId, clientKey);
        const anon_access_token = userDetails?.access_token;
        if (anon_access_token) {
          const detail = await this.authServiceHelper?.getTenantDetails(decryptedTenantId, anon_access_token);
          this.tenantKey = detail?.sso_config?.[0]?.secret;
          effectiveClientId = decryptedTenantId;
          effectiveClientKey = this.tenantKey || clientKey;
        } else {
          console.error('Anonymous token not found in session.');
        }
      } catch (error) {
        console.error('Error fetching tenant details:', error);
      }
    }
  
    const user = {
      "role": defaultUserRole,
      "firstname": userInfoContext ? userInfoContext?.role : "Guest",
      "access_code": null,
      "id": randomId,
      "email": randomEmail,
      "username": randomUsername,
      "firstName": randomUsername
    };

    this.mygContext = {
      "version": version,
      "clientId": effectiveClientId,
      "clientKey": effectiveClientKey,
      "appId": appId,
      "context": {
        "type": MYGOORU_AI_CONTEXT_TYPE,
        "action": INIT_ACTION_TYPE,
        "user": user
      }
    };
    const userData = {
      ...user,
      "queryInput": queryInput || null,
      "queryId": queryId || null,
      "markerId": markerId || null
    };
    localStorage.setItem("user_data_demo_explore", JSON.stringify(userData));
    this.otpService.loggedIn();
    const isPhone = /^\d{10,15}$/.test(randomId);
    this.userContextService.setContact({
      contact: randomUsername,
      contactType: isPhone ? 'phone' : 'email',
    });
  }

  /**
   * @function generateRandomId
   * genrate random id
   */
  private generateRandomId(): string {
    return Math.floor(1000000000 + Math.random() * 9000000000).toString();
  }

  /**
   * @function widgetResizer
   * validateForm method used to resize the container
   */
  public widgetResizer() {
    if (!this.isTabView) {
      setTimeout(() => {
        const element = document.querySelector(
          '#myg-widget-container .myg-widget-panel'
        );
        if (element) {
          const resizeObserver: any = new ResizeObserver((entries) => {
            for (let entry of entries) {
              const width = entry?.contentRect?.width + 50;
              if (this.aiContainer && this.aiContainer.nativeElement) {
                this.aiContainer.nativeElement.style.gridTemplateColumns = `1fr ${width}px`;
              }
            }
          });
          resizeObserver.observe(element);
        }
      }, 1000);
    }
  }
}
